import { Box } from '@mui/material';
import { MprcMessageBox } from 'components';
import React from 'react';
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////

export function isPublicationNotFound(viewError: any) {
    return viewError != undefined && viewError.extensions?.publicationId[0] === "PublicationNotFound";
}

export const PublicationNotFound: React.FC = () => {

    const { t } = useTranslation("knowledge");

    return (
        <Box width={"75%"} margin={"0 auto"}>
            <MprcMessageBox
                fullWidth
                message={t("Publication.Common.PublicationNotFound")}
                variant="error"
            />
        </Box>
    );
};
